<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" display="none">
  <symbol id="icon-arrow-down" viewBox="0 0 12 12">
    <path d="M10,3a1,1,0,0,0-.71.29L6,6.59,2.71,3.29A1,1,0,0,0,1.29,4.71l4,4a1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,0-1.42A1,1,0,0,0,10,3Z"/>
  </symbol>
</svg>

<div class="bmc-trace">
  <bzg-loading class="bmc-trace__loading" [size]="'m'" *ngIf="showLoading else content">{{ loadingMessage }}</bzg-loading>

  <ng-template #content>
    <div class="bmc-trace__filter">
      <strong class="bmc-trace__label-category bz-space--stack-m">{{'TRACE.CATEGORY' | translate}}</strong>
      <bzg-select class="bz-space--stack-m"
        [value]="selectedCategory" (valueChange)="setCategory($event)">
        <bzg-option *ngFor="let category of categories" [value]="category">
          {{ category | upperCategories}}
        </bzg-option>
      </bzg-select>
      <p class="bz-space--stack-m">{{'TRACE.CATEGORY_MESSAGE' | translate}}</p>
      <bz-date-filter [dateMin]="state.dateMin" [dateMax]="state.dateMax" (onBtnFilterClick)="filterFileTraces($event)" [isEventChange]="true">
        <div>
          <bzg-input [(ngModel)]="fileNameFilter" class="bmc-trace__filter__input" placeholder="{{'TRACE.FILTER_FILE_NAME' | translate}}" (keypress)="change($event)"
            name="fileNameFilter" id="fileNameFilter">
            {{'TRACE.FILTER_FILE_NAME' | translate}}
          </bzg-input>
        </div>
      </bz-date-filter>
    </div>
    <div class="blur-loading" *ngIf="showLoading"></div>
    <div class="bmc-trace__options">
      <bzg-button-icon class="bmc-trace__option" [bzgTooltipPosition]="'above'" *ngIf="selectedEntries.length === 1"
            [bzgTooltip]="'TRACE.DOWNLOAD' | translate" icon="icon-download" (click)="downloadFile()"></bzg-button-icon>
      <bzg-button-icon class="bmc-trace__option" [bzgTooltipPosition]="'above'" *ngIf="selectedEntries.length > 0"
            [bzgTooltip]="'TRACE.DELETE' | translate" icon="icon-delete" (click)="showConfirmDialog()"></bzg-button-icon>
      <bzg-button-icon class="bmc-trace__option" [bzgTooltipPosition]="'above'"
            [bzgTooltip]="'TRACE.DISPLAY_DENSITY' | translate" icon="bzg-table-comfortable"
            [bzgMenuTrigger]="menuDisplay"></bzg-button-icon>
    </div>
    <bzg-table [showSelectionColumn]="true" *ngIf="entries && entries.length" [(model)]="entries" [showPaginator]="false"
      (clickItem)="viewdetail($event)" [cellSpacingMode]="cellSpacingMode" (selectItems)="setSelectedEntries($event)"
      [fixedHeader]="true">
      <ng-template bzgTableColumn [allowOrder]="false" title="{{'TRACE.RESULT_FILENAME' | translate}}" let-dataItem="dataItem">
        <p>{{dataItem.Name}}</p>
      </ng-template>
      <ng-template bzgTableColumn [allowOrder]="false" title="{{'TRACE.RESULT_DATE' | translate}}" let-dataItem="dataItem">
        <p>{{ dataItem.Timestamp | showDateFormat:1 }}</p>
      </ng-template>
    </bzg-table>
    <div class="bmc-trace__displayed_records" *ngIf="!showLoading && entries.length > 0">
      <span>{{ 'TRACE.ENTRIES_RESULT' | translate}} {{ entries.length }}</span>
    </div>
    <div class="bmc-trace__no-records" *ngIf="!showLoading && entries.length === 0">
      <img src="assets/img/no_found.png">
      <span>{{ 'TRACE.NO_RECORDS' | translate}}</span>
    </div>
  </ng-template>
  <bzg-menu #menuDisplay [bzgMenuMinWidth]="170">
    <bzg-menu-item>
      <strong>{{'TRACE.DISPLAY_DENSITY' | translate}}</strong>
    </bzg-menu-item>
    <bzg-menu-item (click)="cellSpacingMode = 'comfortable'">
      <bzg-icon class="bz-space--inline-s"
        nameIcon="bzg-table-comfortable">
      </bzg-icon>
      <span>{{'TRACE.DISPLAY_DENSITY_COMFORTABLE' | translate}}</span>
    </bzg-menu-item>
    <bzg-menu-item (click)="cellSpacingMode = 'normal'">
      <bzg-icon class="bz-space--inline-s"
        nameIcon="bzg-table-normal">
      </bzg-icon>
      <span>{{'TRACE.DISPLAY_DENSITY_NORMAL' | translate}}</span>
    </bzg-menu-item>
    <bzg-menu-item (click)="cellSpacingMode = 'compact'">
      <bzg-icon class="bz-space--inline-s"
        nameIcon="bzg-table-compact">
      </bzg-icon>
      <span>{{'TRACE.DISPLAY_DENSITY_COMPACT' | translate}}</span>
    </bzg-menu-item>
  </bzg-menu>
</div>
